const PrivacyPolicyContent = () => {
  return (
    <div className="p-4 text-sm leading-relaxed space-y-6">
      {/* 개인정보처리방침 헤더 */}
      <div className="text-center">
        {/* <h1 className="text-xl font-bold mb-2">개인정보처리방침</h1> */}
        <p className="text-gray-600">
          멍투데이(이하 “회사”라 합니다)는 개인정보보호법의 개인정보 보호 규정을 준수하고 있습니다. 본 개인정보처리방침을 통하여 회사가 이용자로부터 제공받은 개인정보를 어떠한 용도와 방식으로 이용하고 있으며, 개인정보 보호를 위한 조치 방법을 알려드립니다.
        </p>
      </div>

      {/* 개인정보의 처리 목적, 항목 및 보유, 이용기간 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">개인정보의 처리 목적, 항목 및 보유, 이용기간</h2>
        <p className="mb-4">
          회사는 아래와 같은 목적으로 이용자가 직접 제공하는 최소한의 개인정보를 수집하고 있으며, 사전에 이를 알리고 동의를 구하고 있습니다.
        </p>
        
                 <div className="overflow-x-auto">
           <table className="w-full border-collapse border border-gray-300 text-xs">
             <thead>
               <tr className="bg-gray-50">
                 <th className="border border-gray-300 p-2 text-left">서비스 범위</th>
                 <th className="border border-gray-300 p-2 text-left">분류</th>
                 <th className="border border-gray-300 p-2 text-left">수집 및 이용목적</th>
                 <th className="border border-gray-300 p-2 text-left">수집 및 이용항목</th>
                 <th className="border border-gray-300 p-2 text-left">보유, 이용기간</th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <td className="border border-gray-300 p-2">멍투데이 비즈니스</td>
                 <td className="border border-gray-300 p-2">필수</td>
                 <td className="border border-gray-300 p-2">멍투데이 사업 운영 등 회사가 제공하는 중개 서비스 및 정보 제공, 정산 관리</td>
                 <td className="border border-gray-300 p-2">이메일주소(아이디), 연동된 소셜미디어, 전화번호, 상호명, 주소, 영업시간, 영업장 정보, 임직원 정보, 사업자 대표자 이름, 사업자번호, 은행명, 계좌번호, 예금주명, 기기고유번호(UUID)</td>
                 <td className="border border-gray-300 p-2" rowSpan={3}>회원 탈퇴 시 지체없이 파기 (관계 법령에 따라 보존할 필요가 있는 경우 관계 법령에서 요구하는 기한까지)</td>
               </tr>
               <tr>
                 <td className="border border-gray-300 p-2" rowSpan={3}>멍투데이 서비스</td>
                 <td className="border border-gray-300 p-2">필수</td>
                 <td className="border border-gray-300 p-2">멍투데이 사업 운명 및 서비스 제공, 제휴 사업자 정보 제공</td>
                 <td className="border border-gray-300 p-2">이메일주소(아이디), 닉네임, 이름, 휴대폰 번호</td>
               </tr>
               <tr>
                 <td className="border border-gray-300 p-2">필수</td>
                 <td className="border border-gray-300 p-2">멍투데이 서비스 예약 및 위탁계약 업무 처리 등을 위한 유효 보호자 정보</td>
                 <td className="border border-gray-300 p-2">이메일주소(아이디), 닉네임, 보호자 실명, 전화번호, 거주지 주소, 수동 선택한 위치정보</td>
               </tr>
               <tr>
                 <td className="border border-gray-300 p-2">필수</td>
                 <td className="border border-gray-300 p-2">예약관리를 위한 반려동물 정보</td>
                 <td className="border border-gray-300 p-2">반려동물 이름, 품종, 몸무게, 생년월일, 접종정보, 성향정보, 알레르기 정보, 기타 반려동물 정보 등록 정보 일체</td>
                 <td className="border border-gray-300 p-2">반려동물 정보는 보호자 정보를 제외한 비 개인정보의 범위를 영구적으로 보존합니다.</td>
               </tr>
               <tr>
                 <td className="border border-gray-300 p-2">공통</td>
                 <td className="border border-gray-300 p-2">필수</td>
                 <td className="border border-gray-300 p-2">고객상담 및 회원관리, 서비스 이용기록 확인</td>
                 <td className="border border-gray-300 p-2">서비스 이용시간, 이용기록, 접속IP정보, 단말기 모델명, 단말기 OS종류 및 버전, 브라우저 정보, 아이디, 이름, 전화번호, 이메일 주소, 등록 반려동물 정보</td>
                 <td className="border border-gray-300 p-2">회원 탈퇴 시 지체없이 파기 (관계 법령에 따라 보존할 필요가 있는 경우 관계 법령에서 요구하는 기한까지)</td>
               </tr>
             </tbody>
           </table>
         </div>
      </div>
      <div>
         <p className="mb-4">
          단, 아래의 경우 예외적으로 법령에 따라 동의 없이 개인정보를 수집 및 이용할 수 있습니다.
        </p>
        <ol className="list-decimal list-inside space-y-1 text-sm">
          <li>법률에서 특별한 규정이 있거나 법령 상 의무를 준수하기 위하여 불가피한 경우</li>
          <li>정보주체와 체결한 계약을 이행하거나 계약을 체결하는 과정에서 정보주체의 요청에 따른 조치를 이행하기 위하여 필요한 경우</li>
          <li>명백히 정보주체 또는 제 3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
          <li>회사의 정당한 이익을 달성하기 위하여 필요한 경우로서 명백하게 정보주체의 권리보다 우선하는 경우(이 경우 회사의 정당한 이익과 상당한 관련이 있고 합리적인 범위를 초과하지 않는 경우에 한함)</li>
          <li>공중위생 등 공공의 안전과 안녕을 위하여 긴급히 필요한 경우</li>
        </ol>
      </div>
      {/* 개인정보의 제3자 제공 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">개인정보의 제3자 제공</h2>
        <p className="mb-4">
          회사는 이용자의 개인정보를 개인정보의 처리목적에서 명시한 범위 내에서만 처리하며, 이용자의 동의, 법률의 특별한 규정 등에 해당하는 경우에만 개인정보를 제 3자에게 제공하고 그 이외에는 이용자의 개인정보를 제 3자에게 제공하지 않습니다.
        </p>
        <p className="mb-4">
          회사는 원활한 서비스 제공을 위하여 다음의 경우 이용자의 동의를 얻어 개인정보를 제공하고 있습니다.
다음의 경우는 예외적으로 이용자의 사전 동의 없이 이용자 정보를 제공할 수 있습니다
        </p>
        <ol className="list-decimal list-inside space-y-1 text-sm">
          <li>다른 법률에 특별한 규정이 있는 경우</li>
          <li>명백히 정보주체 또는 제 3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
          <li>공중위생 등 공공의 안전과 안녕을 위하여 긴급히 필요한 경우</li>

        </ol>
      </div>

      {/* 개인정보의 파기 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">개인정보의 파기</h2>
        <p className="mb-4">
          회사는 수집 및 이용목적이 달성된 개인정보는 지체없이 파기합니다.
        </p>
        <p className="mb-4">
          정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 내부 방침 또는 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.
        </p>
        <h3 className="font-semibold mb-2">1. 개인정보의 파기 절차와 방법</h3>
        <p className="mb-4">
          회사는 이용자의 서비스 해지 등의 요청이 있는 경우 지체 없이 파기하며, 관계 법령 및 내부 방침에 의해 보유한 경우에도 해당 사유 종료 후 지체 없이 파기합니다.
        </p>
        <h3 className="font-semibold mb-2">2. 파기 방법</h3>
        <p className="mb-4">
          회사는 전자적 파일 형태로 기록 및 저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이문서에 기록 및 저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
        </p>
        <h3 className="font-semibold mb-2">3. 내부 방침에 따라 보유하는 경우</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-2 text-left">보유 사유</th>
                <th className="border border-gray-300 p-2 text-left">보유 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">회사와 이용자간 민원, 소송 등 분쟁과정 중 법률로 정한 보유기간이 경과한 경우</td>
                <td className="border border-gray-300 p-2">분쟁 해결 시까지 보관 후 파기</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">회사가 개별적으로 이용자의 동의를 받은 경우</td>
                <td className="border border-gray-300 p-2">동의받은 기간까지 보관 후 파기</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">정산이 남아있는 경우</td>
                <td className="border border-gray-300 p-2">정산 종료 시 까지 보관 후 파기</td>
              </tr>
            </tbody>
          </table>
        </div>
    <h3 className="font-semibold mt-4 mb-2">4. 관계 법령에 따라 보유하는 경우</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-2 text-left">보유 정보</th>
                <th className="border border-gray-300 p-2 text-left">보유 근거</th>
                <th className="border border-gray-300 p-2 text-left">보유 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">계약 또는 청약 철회에 관한 기록</td>
                <td className="border border-gray-300 p-2">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                <td className="border border-gray-300 p-2">5년</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">대금 결제 및 재화 등의 공급에 관한 기록</td>
                <td className="border border-gray-300 p-2">전자상거래 등에서의 소비자 보호에 관한 법률, 국세기본법, 법인세법, 부가가치세법</td>
                <td className="border border-gray-300 p-2">5년</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">소비자의 불만 또는 분쟁처리에 관한 기록</td>
                <td className="border border-gray-300 p-2">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                <td className="border border-gray-300 p-2">3년</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">표시/광고에 관한 기록</td>
                <td className="border border-gray-300 p-2">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                <td className="border border-gray-300 p-2">6개월</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">본인확인에 관한 기록</td>
                <td className="border border-gray-300 p-2">정보통신망 이용촉진 및 정보보호 등에 관한 법률</td>
                <td className="border border-gray-300 p-2">6개월</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">사이트 방문에 관한 기록</td>
                <td className="border border-gray-300 p-2">통신비밀보호법</td>
                <td className="border border-gray-300 p-2">3개월</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* 개인정보의 처리 위탁 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">개인정보의 처리 위탁</h2>
        <p className="mb-4">
          회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
        </p>
        
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-2 text-left">수탁자</th>
                <th className="border border-gray-300 p-2 text-left">위탁업무</th>
                <th className="border border-gray-300 p-2 text-left">개인정보 보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">Amazon Web Service, Inc.</td>
                <td className="border border-gray-300 p-2">클라우드 인프라 관리</td>
                <td className="border border-gray-300 p-2">회원탈퇴 또는 위탁 계약 종료 시까지</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4 mb-4">
          회사는 데이터 보관 및 인프라 관리 업무를 국외 법인인 Amazon Web Service, Inc.에 다음과 같이 위탁하고 있습니다.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-2 text-left">수탁업체</th>
                <th className="border border-gray-300 p-2 text-left">Amazon Web Service, Inc.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">수탁업체의 위치</td>
                <td className="border border-gray-300 p-2">Amazon Web Service, Inc.의 리전 (한국, 일본, 미국, 런던 등)</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">위탁일시 및 방법</td>
                <td className="border border-gray-300 p-2">서비스 이용 시점에 네트워크를 통한 전송</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">정보관리책임자의 연락처</td>
                <td className="border border-gray-300 p-2">aws-korea-privacy@amazon.com</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">위탁하는 개인정보 항목</td>
                <td className="border border-gray-300 p-2">회사에서 수집, 보관하는 개인정보를 포함하는 데이터의 일체</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">위탁업무 내용</td>
                <td className="border border-gray-300 p-2">재난, 재해로부터의 안전한 이용자 데이터 보호를 위한 국가간 데이터 백업</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">개인정보의 보유 및 이용기간</td>
                <td className="border border-gray-300 p-2">본 개인정보처리방침에 규정된 보관기간과 일치함</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4 mb-4">
          개인정보의 이전을 거부하는 방법, 절차 및 거부의 효과정보주체는 멍투데이의 개인정보 담당부서에 연락하여 개인정보의 국외이전을 거부할 수 있습니다. 단, 개인정보 국외이전을 거부할 경우 멍투데이 서비스 이용에 제한이 발생할 수 있습니다.
        </p>
        <p className="mt-4 mb-4">
          회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리 금지, 기술적 관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리 감동 및 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
        </p>
        <p className="mb-4">
          위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보처리방침을 통하여 공개하도록 하겠습니다.
        </p>

      </div>

      {/* 이용자의 권리, 의무 및 행사 방법 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">이용자의 권리, 의무 및 행사 방법</h2>
        <p className="mb-4">
          이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 정보 삭제 및 처리 정지를 요구할 수도 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부의 이용이 어려워질 수 있습니다. 이용자의 개인정보에 대한 조회, 수정 또는 가입해지 등의 문의에 대한 원활한 의사소통을 위해 고객 문의 채널을 운영하고 있으며 멍투데이 서비스의 고객문의 채널을 통하여 문의하시면 지체없이 조치하겠습니다.
        </p>
        <p className="mb-4">
          법적대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않으며 별도의 서비스 이용을 위한 계약을 원천적으로 제한하고 있습니다.
        </p>
        <h2 className="text-lg font-semibold mb-4">개인정보 보호책임자</h2>
          <p className="mb-2"><strong>개인정보 보호책임자:</strong>김태경</p>
          <p className="mb-2"><strong>이메일 주소:</strong> privacy@mungtoday.com</p>
        <p className="mb-4 text-sm">
          개인정보가 침해되어 이에 대한 신고나 보다 자세한 상담이 필요한 경우에는 회사와는 별도인 다음의 전문 기관에 문의하셔서 도움을 받으실 수 있습니다.
        </p>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-2 text-left">권리침해 신고 및 상담기관</th>
                <th className="border border-gray-300 p-2 text-left">전화</th>
                <th className="border border-gray-300 p-2 text-left">웹사이트</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">개인정보 침해신고센터</td>
                <td className="border border-gray-300 p-2">(국번없이)118</td>
                <td className="border border-gray-300 p-2">privacy.kisa.or.kr</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">개인정보 분쟁조정위원회</td>
                <td className="border border-gray-300 p-2">(국번없이)1833-6972</td>
                <td className="border border-gray-300 p-2">www.kopico.go.kr</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">대검찰청 사이버수사과</td>
                <td className="border border-gray-300 p-2">(국번없이)1301</td>
                <td className="border border-gray-300 p-2">www.spo.go.kr</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">경찰청 사이버안전국</td>
                <td className="border border-gray-300 p-2">(국번없이)182</td>
                <td className="border border-gray-300 p-2">ecrm.police.go.kr</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 className="text-lg font-semibold mb-2 mt-4">
          개인정보의 자동수집장치 설치, 운영, 거부사항
        </h2>
      <p className="mb-4 text-sm">
        회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위하여 이용정보를 저장하고 수시로 불러오는 쿠키(Cookie)를 사용합니다.
      </p>
      <p className="mb-4 text-sm">
        쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에 보내는 소량의 정보이며 이용자들의 서비스 이용 디바이스(기기)의 저장공간에 저장되기도 합니다.
      </p>
      <h3 className="font-semibold mb-2">1. 쿠키 사용 목적</h3>
      <p className="mb-4">
        이용자가 방문한 각 서비스와 웹사이트들에 대한 방문 및 이용형태, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보를 제공하기 위하여 사용합니다.
      </p>
      <h3 className="font-semibold mb-2">2. 쿠키의 설치, 운영 및 거부</h3>
      <p className="mb-4">
        이용자는 웹브라우저 상단의 도구 {'>'} 인터넷 옵션 {'>'} 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
      </p>
      </div>



      {/* 개인정보 처리방침의 변경 */}
      <div>
        <h2 className="text-lg font-semibold mb-4">개인정보 처리방침의 변경</h2>
        <p className="mb-4">
          회사는 개인정보 처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
        </p>
        <p className="text-center font-semibold">
          개인정보 처리방침 시행일자: 2025년 3월 4일
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent; 